export default () => ({
  withBatchComments: false,
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  currentlyPublishingDrafts: [],
  isDiscarding: false,
  showPreviewDropdown: false,
});
